import { groupTagSchema, type GroupTag } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import group tags to the global cache from a list of group tags.
 *
 * @param groupTags - array of GroupTags
 */
function importGroupTags(groupTags: GroupTag[]) {
  const parsedResult = filteredArray(groupTagSchema).safeParse(groupTags);
  if (parsedResult.success) {
    importEntities(QueryKeys.groupTags.global, parsedResult.data);
  }
}

export { importGroupTags };
